var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticStyle:{"margin":"10px 0"}},[_c('md-card-content',[_c('BlogItem',{attrs:{"item":_vm.previewItem}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }